<style scoped>

  #receivables-segment {
    min-height: 300px;
  }

</style>

<template>
  
  <div>

    <div class="ui large breadcrumb">      
      <router-link to="/financial/receivables" class="clickable">
        <i class="reply icon m-r-5"></i> Títulos a Receber
      </router-link>
      <i class="right chevron icon divider"></i>
      <div class="bold section">
        Baixas a Receber
      </div>
    </div>

    <div class="ui divider"></div>

    <settles-filter ref="filter" @onApply="onApplyFilter" /> 

    <div id="receivables-segment" class="ui segment" :class="{ loading }">
      
      <h4 class="ui dividing header">Títulos</h4>
      
      <p v-if="!status" class="grey text m-t-15">
        <i class="info circle icon"></i> Defina os filtros para selecionar os títulos
      </p>

      <p v-if="status == 'not_found'" class="grey text m-t-15">
        <i class="info circle icon"></i> Nenhum título encontrado. Verifique os filtros informados.
      </p>

      <settles-grid v-show="status == 'found'" ref="grid" />

    </div>

    <button class="ui right floated blue button m-t-5" :class="{ disabled: status != 'found', loading: saving }" @click="onConfirm()">
      <i class="check icon"></i> Confirmar
    </button>

    <router-link to="/financial/receivables" class="ui basic button m-t-5">
      <i class="reply icon"></i> Cancelar
    </router-link>

  </div>

</template>

<script>

  import _ from "underscore"
  import moment from "@/utils/moment"
  import ReceivableService from "@/services/receivable-service"
  import SettlesFilter from "./filter.vue"
  import SettlesGrid from "./grid.vue"

  export default {
    
    name: "ReceivablesSettlesPage",

    data() {
      return {
        loading: false,
        saving: false,
        status: null,
        service: new ReceivableService(),
      }
    },

    components: {
      SettlesFilter,
      SettlesGrid,
    },

    methods: {

      async onApplyFilter(filter) {

        if (this.loading)
          return

        this.loading = true
        
        try {

          filter.startDueDate = moment(filter.startDueDate).format("YYYY-MM-DD")
          filter.endDueDate = moment(filter.endDueDate).format("YYYY-MM-DD")
          filter.order = "realDueDate"

          let receivables = await this.service.filter(filter)

          for (let receivable of receivables) {
            receivable.sortKey = moment(receivable.dueDate).format("YYYYMMDD") + receivable.customer.shortName.trim().toLowerCase()
          }

          if (receivables.length == 0) {
            this.status = "not_found"
          } else {
            this.$refs.grid.setReceivables(_.sortBy(receivables, "sortKey"))
            this.status = "found"
          }
          
        } catch (error) {
          
          this.$errorHandler(error)
        
        } finally {

          this.loading = false
        }
      },

      async onConfirm() {

        if (this.saving)
          return

        const settles = this.$refs.grid.getSettles()

        if (!settles.length)
          return this.$msg.info("Nenhum título selecionado")

        this.saving = true  

        try {

          for (const settle of settles) {
            if (settle.action == "undo") {
              await this.service.deleteSettle(settle.receivableId, "last")
            } else {
              await this.service.settle(settle.receivableId, settle)
            }
          }

          this.$reloadDataTables(["receivables"])

          this.$msg.success("Processamento realizado com sucesso")

          this.$router.push("/financial/receivables")
          
        } catch (error) {
          
          this.$errorHandler(error)
        
        } finally {

          this.saving = false
        }
      },
    },
  }

</script>